import { Button } from "@components/ui/button"
import { useAccountOfferFunnel } from "../utils/useAccountOfferFunnel"
import { useChooseOfferColumns } from "../utils/tableColumnSchema"
import { DataTable } from "@components/DataTable/DataTable"
import { useOffersSerializer } from "../utils/useOffersSerializer"

export const ChooseOffer = () => {
  const { data, isPending, isError, error } = useOffersSerializer()
  const { setStep, offerType } = useAccountOfferFunnel()

  const chooseOfferColumns = useChooseOfferColumns()

  const ineligibleMessage =
    offerType === "Retention"
      ? "This member has no retention offers available on the account. The member may continue on their existing plan, or elect to cancel."
      : "This member has no winback offers available on the account. The member cannot be wonback."

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <h4 className="tw:text-xl tw:font-semibold">{offerType} Offers</h4>
      {isError ? (
        <div className="tw:py-4 tw:text-red-500">
          Error loading {offerType} offers. {error?.message}
        </div>
      ) : (
        <>
          {data?.path?.path_type?.toUpperCase() === "INELIGIBLE" ? (
            <p>{ineligibleMessage}</p>
          ) : (
            <DataTable
              columns={chooseOfferColumns}
              data={data?.eligible_offers ?? []}
              pending={isPending}
              noResultsMessage={"No offers available at this time."}
            />
          )}

          {data && <p className="tw:px-1">Request Id: {data.requestId}</p>}
        </>
      )}

      <div className="tw:flex tw:justify-between">
        <Button variant="secondary" onClick={() => setStep("initial")}>
          Go Back
        </Button>
        {offerType === "Retention" && (
          <Button variant="destructive" onClick={() => setStep("cancelMember")}>
            Cancel Account
          </Button>
        )}
      </div>
    </div>
  )
}
